angular.module("app").controller("globalColorController", [
  "$scope",
  function (
    scope
  ) {

  },
]);
